window.dataLayer = window.dataLayer || [];

import { clickHandler, determineActionText, queryURL } from '@/scripts/analytics/analytics.methods';

const components = [
  {
    eventName: 'contactUsTriage_tracking',
    actionPropTitle: 'contactUsTriage_action',
    labelPropTitle: 'contactUsTriage_label',
    element: document.querySelector('.js-contact-triage-ga'),
  },
  {
    eventName: 'connectionsTriage_tracking',
    actionPropTitle: 'connectionsTriage_action',
    labelPropTitle: 'connectionsTriage_label',
    element: document.querySelector('.js-connections-triage-ga'),
  },
];

const triageTabpanelClass = '.js-triage-tabpanel-ga';
const triageTriggerClass = '.js-triage-trigger-ga';

function bindEventListenerPrimary(el, comp) {
  el.addEventListener(
    'click',
    clickHandler.bind(this, {
      event: comp.eventName,
      actionProp: comp.actionPropTitle,
      labelProp: comp.labelPropTitle,
      action: `Click - Primary Level`,
      label: el.innerText,
    }),
  );
}

function bindEventListenerSecondary(el, comp) {
  el.addEventListener(
    'click',
    clickHandler.bind(this, {
      event: comp.eventName,
      actionProp: comp.actionPropTitle,
      labelProp: comp.labelPropTitle,
      action: `Click - ${determinePrimaryLabel(el, comp)} - ${determineActionText(el)}`,
      label: queryURL(el) || window.location.pathname,
    }),
  );
}

function determinePrimaryLabel(el, comp) {
  const id = el.closest(triageTabpanelClass).id;
  const primaryBtn = comp.element.querySelector(`[aria-controls='${id}']`).innerText;
  return primaryBtn;
}

function init() {
  components.forEach((comp) => {
    if (!comp.element) {
      return;
    }

    const primaryLinks = [...comp.element.querySelectorAll(triageTriggerClass)];
    primaryLinks.forEach((link) => bindEventListenerPrimary(link, comp));

    const triageTabpanels = [
      ...comp.element.querySelectorAll(`${triageTabpanelClass} a, ${triageTabpanelClass} button`),
    ];
    triageTabpanels.forEach((link) => bindEventListenerSecondary(link, comp));
  });
}

export default init;
